// Utilities to build safe URLs for navigating to detail pages.

// 基于自定义字符清理与标题格式化的算法
// replaceChar：去除指定的特殊符号
const replaceChar = (s: string) => {
  const pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
  let rs = ""
  for (let i = 0; i < s.length; i++) {
    rs = rs + s.substr(i, 1).replace(pattern, "")
  }
  return rs
}

// titleFormat：核心的标题格式化函数
// 支持 options：lower（默认 false）、maxLength（默认 120），并在结果为空时回退到 'smm-news'
const titleFormat = (title: string, options?: { lower?: boolean; maxLength?: number }): string => {
  const lower = options?.lower ?? false
  const maxLength = options?.maxLength ?? 120

  let s = (title || "").normalize("NFKC")
  s = replaceChar(s)
  s = s.replace(/%/g, "")
  s = s.replace(/  /g, " ")
  s = s.replace(/ /g, "-")
  if (lower) s = s.toLocaleLowerCase()

  if (maxLength > 0 && s.length > maxLength) s = s.slice(0, maxLength)
  if (!s) s = ""
  return s
}

export { replaceChar, titleFormat }
